module.exports = __webpack_public_path__ + "media/ToDust-shades.d2edac06.mp3";